import { render, staticRenderFns } from "./DeleteContactFromStaticLists.vue?vue&type=template&id=65cbe516&scoped=true&lang=pug"
import script from "./DeleteContactFromStaticLists.vue?vue&type=script&lang=js"
export * from "./DeleteContactFromStaticLists.vue?vue&type=script&lang=js"
import style0 from "./DeleteContactFromStaticLists.vue?vue&type=style&index=0&id=65cbe516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbe516",
  null
  
)

export default component.exports